import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type Integration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationCalendlySettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationCalendlySettings/store/IntegrationCalendlySettingsStore'
import { CollapseIntegrationSettingsUsers } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsUsers/CollapseIntegrationSettingsUsers'

type IIntegrationCalendlySettings = {
  integration: Integration
}

export const IntegrationCalendlySettings: FC<IIntegrationCalendlySettings> = observer(
  ({ integration }) => {
    const entities = useEntitiesContext()
    const { collapseStore, userStore } = useIntegrationStoreMemo(
      IntegrationCalendlySettingsStore,
      integration,
      entities
    )

    return (
      <div>
        <CollapseIntegrationSettingsUsers collapseStore={collapseStore} userStore={userStore} />
      </div>
    )
  }
)
